import CreateOrEditCampaign from './CreateOrEditCampaign'

export default CreateOrEditCampaign
